import { EStalkerBannerActions, IHideStalkerBanner, IShowStalkerBanner } from '../actions';

export type TStalkerBannerAction =
  IShowStalkerBanner |
  IHideStalkerBanner;

export function stalkerBanner(state: boolean = false, action: TStalkerBannerAction) {
  switch (action.type) {
    case EStalkerBannerActions.show:
      return true;
    case EStalkerBannerActions.hide:
      return false;
    default:
      return state;
  }
}
